import { connect } from "react-redux";
import ViewHelper from "./viewHelpers";
import { bindActionCreators } from "redux";
import {listing} from "../../../services/redux/HelperDetails/action";

const mapStateToProps = (state) => ({
    list: state.HelperDetails.list,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        listing
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewHelper);
